import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SearchMainComponent } from '@franbase/frontend/shared/search-main';
import { GradientBtnComponent } from '@franbase/frontend/shared/ui/gradient-btn';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { LinkDropdownItemComponent } from '../link-dropdown-item/link-dropdown-item.component';
import { menus } from './dummyMenu';
import { ApiService, AuthService } from '@franbase/shared/data-access';
import { combineLatest, map } from 'rxjs';
import { CategoryStoreService } from '@franbase/frontend/data-access';
import { AuthStore } from '@franbase/shared/auth/data-access';

type UserType = { name: string, avatar: string };

@Component({
  selector: 'franbase-main-menu',
  standalone: true,
  imports: [
    CommonModule,
    GradientBtnComponent,
    NzDropDownModule,
    SvgIconComponent,
    SearchMainComponent,
    NzButtonModule,
    RouterModule,
    NzTabsModule,
    LinkDropdownItemComponent,
  ],
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainMenuComponent {

  authStore = inject(AuthStore);
  authSV = inject(AuthService);
  categoryStoreSV = inject(CategoryStoreService);
  apiSV = inject(ApiService);
  router = inject(Router);
  @Output() handleMenu = new EventEmitter<boolean>();

  showDropdownCate = false;

  visible = false;
  showSearch = false;
  HEADER_COLLAPSED_AT = 1280;

  user?: UserType;

  auth_profile$ = this.authStore.authProfile$;

  menus$ = combineLatest(this.categoryStoreSV.industry$, this.categoryStoreSV.location$, this.categoryStoreSV.investment$).pipe(
    map(([industry, location, investment]) => {
      // console.log(industry, location, investment);

      let temp: any = menus;
      let industry_temp: any[] = [];
      industry.forEach((i: any) => {
        let obj = {
          level: 3, selected: false, disabled: false, title: i.title, link: '/industry/'+i.slug, fire: i.featured
        }
        industry_temp.push(obj);
      });

      let location_temp: any[] = [];
      location.forEach((i: any) => {
        let obj = {
          level: 3, selected: false, disabled: false, title: i.title, link: '/location/'+i.slug, fire: i.featured
        }
        location_temp.push(obj);
      });

      let investment_temp: any[] = [];
      investment.forEach((i: any) => {
        let obj = {
          level: 3, selected: false, disabled: false, title: i.title, link: '/investment/'+i.slug, fire: i.featured
        }
        investment_temp.push(obj);
      });

      temp[0].children[0].children = industry_temp;
      temp[0].children[1].children = location_temp;
      temp[0].children[2].children = investment_temp;

      return temp;
    })
  )

  log(args: any[]): void {
    // console.log(args);
  }

  handleUpdateShowSearch(value: boolean): void {
    this.showSearch = value;
  }

  closeMenu(): void {
    this.handleMenu.emit(false);
  }

  handleSetDropdown(value: boolean): void {
    this.showDropdownCate = value;
  }

  logout() {
    this.authSV.logOut();
  }
}
